import React, { useEffect, useState } from "react";
import { Importer, ImporterField } from "react-csv-importer";
import { Col, Form, Row } from "react-bootstrap";

// theme CSS for React CSV Importer
import "react-csv-importer/dist/index.css";
import { Api } from "../../../../helpers/Api";
import { v4 as uuidv4 } from "uuid";
import LoadingSpinner from "../../Components/Spinner/LoadingSpinner";

// sample importer usage snippet, play around with the settings and try it out!
// (open console output to see sample results)
let importedRows = [];
const CSV = () => {

    const [selectedTemplateIndex, setSelectedTemplateIndex] = useState(null);
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState();
    const [templates, setTemplates] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [confirmation, setConfirmation] = useState(false);
    const [result, setResult] = useState(null);
    const [certificateCount, setCertificateCount] = useState(0);
    const [showSearch, setShowSearch] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.addEventListener('click', function(event) {
            if(event && event?.target && event?.target?.className?.includes("WClick")){
                setShowSearch(true);
            }
            else{
                setShowSearch(false);
            }
        });
        Api.getTemplates().then(response => {
            setEvents(response);
        }).finally(()=>{
            setLoading(false);
        });
    }, []);

    const reset = () => {
        importedRows = [];
        window.location.reload();
    };
    const proceed = async () => {
        setProcessing(true);
        let template = templates[selectedTemplateIndex];
        let r = { success: 0, failed: 0, count: 0};
        for (let i = 0; i < importedRows.length; i++) {

            const payload = { data: {}, template: { brand :{}, data: {} } };
            payload.templateData = template;
            payload.template = selectedEvent;
            payload.uuid = uuidv4();
            payload.data = importedRows[i];
            try {
                r.count++;
                setCertificateCount(r.count);
                await Api.updateCertificate(payload);
                r.success++;
            } catch (e) {
                r.failed++;
            }
        }
        importedRows = [];
        setResult(r);
        setProcessing(false);   
    };

    let hasName = templates[selectedTemplateIndex]?.labels?.find(label => {
        return label.text.toLowerCase() === "name";
    });

    let hasEmail = templates[selectedTemplateIndex]?.labels?.find(label => {
        return label?.text.toLowerCase() === "email";
    });

    return loading ? <LoadingSpinner /> :<div className="right_container">
        <div className="dashboard">
            
            <div className="inner-content csv">
            <h4>Import CSV</h4>
                <div className="select-events1">
                    <div className="commen-form">
                        <Form>
                    <Row>
                        <Col md={4}>
                            <Form.Label>Please select event</Form.Label>
                            <input placeholder='Please Select' className='form-control WClick' type='text' value={selectedEvent?.name} onClick={()=>{setSelectedEvent("")}} onChange={(e)=>{setSelectedEvent(e.target.value)}}/> 
                            {showSearch && <div className={'dropdown-content'}>
                                {selectedEvent != null && selectedEvent != "" && <div>Please Select</div> && events.map((e) => {
                                    if(typeof selectedEvent === "string" && e.name.toLowerCase().includes(selectedEvent.toLowerCase())){
                                        return <div onClick={()=>{
                                            setTemplates(e.data);
                                            setSelectedEvent(e);
                                    }}>{e.name}</div>   
                                }
                                })
                                }
                                {(selectedEvent == null || selectedEvent == "") && <div>Please Select</div> && events.map((e) => {
                                    return <div onClick={()=>{
                                        setTemplates(e.data);
                                        setSelectedEvent(e);
                                    }}>{e.name}</div>
                                })}
                            </div>}
                            {/* <Form.Select className="form-control form-control1" onChange={e => {
                                let t = events?.find(t => {
                                    return t.id == e.target.value
                                });
                                setTemplates(t.data);
                                setSelectedEvent(t);
                            }
                            }>
                                <option value="" selected>Please Select</option>

                                {events?.map((t, index) => {
                                    return <option value={t.id}>{t.name}</option>
                                })}
                                </Form.Select> */}
                        </Col>
                        {templates &&
                            <Col md={4}>
                                <Form.Label>Please select event</Form.Label>
                                <Form.Select 
                                    className="form-control form-control1" value={selectedTemplateIndex} onChange={e => {
                                    setSelectedTemplateIndex(e.target.value)
                                }
                                }>
                                    <option value="" selected>Please Select</option>
                                    {templates?.map((t, index) => {
                                        return <option value={index}>{t.TemplateName}</option>
                                    })}
                                </Form.Select>
                            </Col>}
                    </Row>
                    </Form>
                    </div>
                </div>
                {confirmation && !processing && !result &&
                    <div className="confirm text-white">
                        <p>You are about to generate {importedRows.length} certificates.</p>
                        <div className='Form-buttons'>
                            <button className='cancel' type="button" onClick={reset}>Cancel</button>
                            <button className='submit' type="button" onClick={proceed}>Proceed</button>
                        </div>
                    </div>

                }
                {result &&
                    <div className="result text-white">
                        <p> Success: {result.success}</p>
                        <p> Failed: {result.failed}</p>
                    </div>
                }
                {!confirmation || processing || result &&
                        <div className='Form-buttons'>
                            <button className='cancel' type="button" onClick={reset}>Cancel</button>
                        </div>
                }
                {processing &&
                    <div className="processing text-white">
                        <h4>{certificateCount} out of {importedRows.length} Processing, please wait...</h4>
                        <div className='Form-buttons'>
                            <button className='cancel' type="button" onClick={reset}>Cancel</button>
                        </div>
                    </div>
                }
                {!!selectedTemplateIndex && !confirmation &&
                    <Importer
                        chunkSize={10000} // optional, internal parsing chunk size in bytes 
                        assumeNoHeaders={false} // optional, keeps "data has headers" checkbox off by default
                        restartable={false} // optional, lets user choose to upload another file when import is complete
                        onStart={({ file, fields }) => {
                            // optional, invoked when user has mapped columns and started import
                            console.log("starting import of file", file, "with fields", fields);
                        
                        }}
                        processChunk={async (rows) => {
                            // required, receives a list of parsed objects based on defined fields and user column mapping;
                            // may be called several times if file is large
                            // (if this callback returns a promise, the widget will wait for it before parsing more data)
                            // console.log("received batch of rows", rows);
                            importedRows = [...importedRows, ...rows];
                        }}
                        onComplete={({ file, fields }) =>  {
                            // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
                            setConfirmation(true);
                        }}
                        onClose={() => {
                            // optional, invoked when import is done and user clicked "Finish"
                            // (if this is not specified, the widget lets the user upload another file)
                        }}
                    >
                        {/* {!hasName &&
                        <ImporterField name={'name'} label="Name" />
                        } */}

                        {!hasEmail &&
                        <ImporterField name={'email'} label="Email" />
                        }

                        {templates[selectedTemplateIndex].label.map(label => {
                            return <ImporterField name={label.text} label={label.text} />
                        })}
                    </Importer>
                }
            </div></div></div>
}

export default CSV;
